import { render, staticRenderFns } from "./ActionIcon.vue?vue&type=template&id=7ddd40eb"
import script from "@/components/action-icon/ActionIcon.ts?vue&type=script&lang=ts&external"
export * from "@/components/action-icon/ActionIcon.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/action-icon/action-icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports